import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsActionMaintenanceToggleActiveParm } from "./wsActionMaintenanceActionInfo";
import { wsActionMaintenanceToggleBasicParm } from "./wsActionMaintenanceActionInfo";
import { wsActionMaintenanceActionGetDataParm } from "./wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionAddParm } from "./wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionUpdateParm } from "./wsActionMaintenanceActionModifyInfo";

@Injectable()
export class DataService_ActionMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceActionSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceActionSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/ActionMaintenanceActionSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceToggleActive(parms: wsActionMaintenanceToggleActiveParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/ActionMaintenanceToggleActive";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceToggleBasic
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceToggleBasic(parms: wsActionMaintenanceToggleBasicParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/ActionMaintenanceToggleBasic";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceActionDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceActionDataGet(parms: wsActionMaintenanceActionGetDataParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/ActionMaintenanceActionDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceActionAdd
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceActionAdd(parms: wsActionMaintenanceActionAddParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/ActionMaintenanceActionAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceActionUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceActionUpdate(parms: wsActionMaintenanceActionUpdateParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/ActionMaintenanceActionUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
